import * as React from "react";

interface ArrowIconProps {
    direction?: "left" | "right";
    disabled?: boolean;
}

const ArrowIcon = ({
    direction = "right",
    disabled = false,
}: ArrowIconProps) => {
    const strokeColor = disabled ? "#D1D2D5" : "#98999D";

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="14"
            fill="none"
            viewBox="0 0 8 14"
            style={
                direction === "left"
                    ? { transform: "rotate(180deg)" }
                    : undefined
            }
        >
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M.75.75s6 4.419 6 6-6 6-6 6"
            ></path>
        </svg>
    );
};

export default ArrowIcon;
